export const notFound = {
  title: 'Упс! Страница не найдена',
  description1: 'Что-то пошло не так.',
  description2: 'Кажется, ссылка неправильная или страницы не существует',
  button: 'Домой',
};
